
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(111|362|45|519)|6(127|386|560|717)|1(291|413|865|940|987)|8(507|76|860)|7(34[12]|162|512|581|71|744)|3(230|304|565|901)|9((29|38|69)3|639|809|867)|2280|2309|4660|4726)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
